import React from 'react';

import {
  CardDetailsCard,
  SubcribedPlanCard,
  UpcomingInvoiceCard,
} from '@/modules/payment';

const CardsContainer = () => {
  return (
    <div className='flex w-full flex-col gap-24 desktop:flex-row'>
      <SubcribedPlanCard />
      <CardDetailsCard />
      <UpcomingInvoiceCard />
    </div>
  );
};

export { CardsContainer };
